// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"ModalReportBackdrop_backdrop__3t5am"};